import React from "react";

import { Container, StyledFillEmailIcon } from "./styles";

export const Article20ThemeSignUpButtonDisplay: React.FunctionComponent = () => (
  <Container>
    <StyledFillEmailIcon />
    GET OUR NEWSLETTER
  </Container>
);

Article20ThemeSignUpButtonDisplay.displayName = "Article20ThemeSignUpButtonDisplay";
